import React from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

const Pagination = ({ currentPage, totalPages, onPageChange, totalItems, itemsPerPage }) => {
    if (totalPages <= 1) return null;

    const renderPageNumbers = () => {
        const pages = [];
        const range = 1; // Number of buttons around the current page

        // Helper to add a button
        const addPageButton = (num) => {
            pages.push(
                <button
                    key={num}
                    onClick={() => onPageChange(num)}
                    className={`w-10 h-10 rounded-xl font-bold text-sm transition-all flex items-center justify-center ${currentPage === num
                        ? 'bg-[#00b259] text-white shadow-md'
                        : 'text-gray-500 hover:bg-slate-100'
                        }`}
                >
                    {num}
                </button>
            );
        };

        // Always show page 1
        addPageButton(1);

        if (currentPage > range + 2 && totalPages > 2) {
            pages.push(<span key="ell-1" className="px-2 text-gray-400">...</span>);
        }

        // Middle pages
        for (let i = Math.max(2, currentPage - range); i <= Math.min(totalPages - 1, currentPage + range); i++) {
            addPageButton(i);
        }

        if (currentPage < totalPages - range - 1 && totalPages > 2) {
            pages.push(<span key="ell-2" className="px-2 text-gray-400">...</span>);
        }

        // Always show last page
        if (totalPages > 1) {
            addPageButton(totalPages);
        }

        return pages;
    };

    return (
        <div className='mt-12 mb-8 bg-white py-4 px-6 rounded-2xl border border-gray-100 shadow-sm flex flex-col md:flex-row items-center justify-between gap-4'>
            <div className='text-gray-500 text-sm'>
                Showing <span className='font-bold text-[#143d2c]'>{((currentPage - 1) * itemsPerPage) + 1}</span> to <span className='font-bold text-[#143d2c]'>{Math.min(currentPage * itemsPerPage, totalItems)}</span> of <span className='font-bold text-[#143d2c]'>{totalItems}</span> results
            </div>

            <div className='flex items-center gap-2'>
                {/* <div className='hidden md:flex items-center gap-2 mr-4'>
                    <span className='text-gray-400 text-xs font-bold uppercase tracking-wider'>Page size:</span>
                    <div className='bg-slate-50 border border-slate-200 rounded-lg text-xs font-bold py-1 px-2 text-[#143d2c]'>
                        {itemsPerPage}
                    </div>
                </div> */}

                <div className='flex items-center gap-1'>
                    <button
                        disabled={currentPage === 1}
                        onClick={() => onPageChange(currentPage - 1)}
                        className='w-10 h-10 flex items-center justify-center rounded-xl border border-gray-100 hover:bg-slate-50 disabled:opacity-30 transition-all text-gray-500 bg-white'
                    >
                        <FaAngleLeft size={14} />
                    </button>

                    {renderPageNumbers()}

                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => onPageChange(currentPage + 1)}
                        className='w-10 h-10 flex items-center justify-center rounded-xl border border-gray-100 hover:bg-slate-50 disabled:opacity-30 transition-all text-gray-500 bg-white'
                    >
                        <FaAngleRight size={14} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Pagination;
